import React, { useEffect, useState } from 'react'
import ReportHeader from '../../../../common/ReportHeader'
import { Box, Button, Grid, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { onlineReportMenu, reportMenu } from '../../../../../redux/Actions'
import MultiSelectDropDown from '../../../../form-components/MultiSelectDropDownComponent'
import excelExport from '../../../../../assets/extra/export-excel'
import { TableHeaderColumn, excelConfig } from './Constants'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../../assets/fonts/Roboto-bold'
import { callAddFontRobotoNormal } from '../../../../../assets/fonts/Roboto-normal'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth } from '../../AccountsReports/PreponePostpone/Constants'
import autoTable from 'jspdf-autotable'
import { focusElemnt, formatDate, navigation1, navigation3 } from '../../../../../utilityFunctions'
import CustomDatePickerV2 from '../../../../common/CustomDatePickerV2'
import moment from 'moment'
import { getMonthalyDetSummary } from '../../../../../redux/KSRTC_Redux/ReportsPage/ReportsAction'
import Alert from '../../../../common/Alert'
import { getTotalByKey } from '../../../../generics/helper'
import MonthWiseEBookingServiceTable from './MonthWiseEBookingServiceTable'
import { getPaymentGatewayList } from '../../../../../redux/KSRTC_Redux/MasterConfig/MasterAction'
const MonthWiseEBookingService = () => {
    const dispatch = useDispatch()
    const store = useSelector((store) => store);
    const { user, masterConfig } = store
    const { paymentGatewayList } = masterConfig
    const [selValues, setSelValues] = useState({ bookDate: moment(formatDate(window.getTime ? window.getTime() : new Date())).format("YYYY-MM-") + "01", toDate: moment(formatDate(window.getTime ? window.getTime() : new Date())).format("YYYY-MM-") + moment(formatDate(window.getTime ? window.getTime() : new Date())).daysInMonth(), pgType: [], })
    const [showAlert, setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [showReport, setShowReport] = useState(false)
    const [reportTableData, setReportTableData] = useState({})
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    useEffect(() => {
        focusElemnt('fromBookingDate')
    }, [])
    useEffect(() => {
        if (user?.CompanyID) {
            const paymentGatewayBody = { PGID: 0, }
            dispatch(getPaymentGatewayList(paymentGatewayBody, true, 60 * 60 * 1000))
        }

    }, [user?.CompanyID])
    useEffect(() => {
        if (paymentGatewayList?.length > 0) {
            setSelValues((prev) => ({ ...prev, pgType: [paymentGatewayList[0]] }))
        }
    }, [paymentGatewayList])
    const paymentTypeProps = () => {
        return {
            id: 'paymentType',
            width: "100%",
            name: "paymentType",
            label: "",
            isCompulsory: false,
            options: paymentGatewayList || [],
            preSelectedValues: selValues?.pgType,
            searchPlaceholder: "Search by Payment Gateway Type",
            disabled: false,
            isObject: true,
            primaryKey: 'PGID',
            labelKey: 'PGName',
            singleSelect: true,
            selectAllOption: false,
            defaultAllSelected: true,
            prevId: "toBookingDate",
            nextId: "submitBTN",
        }
    }
    const groupData = (array) => {
        let newData = []
        let totalarray = []
        let groupedData = array.reduce((result, item) => {
            // const key = `${item.PGName}`
            const key = item.PGName === 'RAZORPAY' ? 'Kotak - Razorpay' : `Kotak - Easebuzz`
            if (!result[key]) {
                result[key] = []
            } result[key].push(item)
            return result
        }, {})
        Object.keys(groupedData).forEach((key) => {
            const keys = ["SuccessCount", "SuccessAmount", "CancelledCount", "CancelledAmount", "CancelPtc", "FailureCount", "FailureAmount", "FailurePtc"];
            let updatedData = groupedData[key]?.map((val, i) => ({ ...val, isDataRow: true, }));
            let totals = getTotalByKey(groupedData[key], keys);
            totals = {
                ...totals,
                SuccessAmount: Math.round(Number(totals?.SuccessAmount)),
                CancelledAmount: Math.round(Number(totals?.CancelledAmount)),
                FailureAmount: Math.round(Number(totals?.FailureAmount)),
                CancelPtc: Math.round((totals.CancelledCount * 100) / totals.SuccessCount),
                FailurePtc: Math.round((totals.FailureCount * 100) / totals.SuccessCount),
            }
            totals.totalCaption = "Total"
            totals.isTotalRow = true
            totals.totalCaptionAllignment = 'left'
            totals.colSpan = 1
            totalarray.push(totals)
            updatedData.push(totals)
            updatedData.unshift({ isHeaderRow: true, TxnDate: 'Date', SuccessCount: 'Txn', SuccessAmount: 'Amount', CancelledCount: 'Txn', CancelledAmount: 'Amount', CancelPtc: '%', FailureCount: 'Txn', FailureAmount: 'Amount', FailurePtc: '%' },)
            updatedData.unshift({ isSubHeadingRow: true, isSubHeading: true, subHeadingData: [{ caption: 'Success', value: '', colSpan: 3 }, { caption: 'Cancelled', value: '', colSpan: 3 }, { caption: 'Failure', value: '', colSpan: 3 }] })
            updatedData.unshift({ isSubHeadingRow: true, isSubHeading: true, subHeadingData: [{ caption: key, value: '', colSpan: 9 }] })
            newData = [...newData, ...updatedData]
        })
        const keys = ["SuccessCount", "SuccessAmount", "CancelledCount", "CancelledAmount", "CancelPtc", "FailureCount", "FailureAmount", "FailurePtc"];
        let allTotal = getTotalByKey(totalarray, keys);
        allTotal = {
            ...allTotal,
            SuccessAmount: Math.round(Number(allTotal?.SuccessAmount)),
            CancelledAmount: Math.round(Number(allTotal?.CancelledAmount)),
            FailureAmount: Math.round(Number(allTotal?.FailureAmount)),
            CancelPtc: Math.round((allTotal.CancelledCount * 100) / allTotal.SuccessCount),
            FailurePtc: Math.round((allTotal.FailureCount * 100) / allTotal.SuccessCount),
        }
        allTotal.totalCaption = "Grand Total"
        allTotal.isTotalRow = true
        allTotal.totalCaptionAllignment = 'left'
        allTotal.colSpan = 1
        newData.push(allTotal)
        return newData
    }
    const reportExcelExport = async () => {
        if (moment(selValues?.toDate).diff(moment(selValues?.bookDate), "month") > 12) {
            handleAlert("This report cannot be taken for more than 1 year")
        } else {
            const body = {
                CompanyID: user?.CompanyID,
                UserID: user?.UserID,
                TxnDateFrom: selValues?.bookDate,
                TxnDateTo: selValues?.toDate,
                PGType: selValues?.pgType?.[0]?.PGUsed,
            }
            const res = await dispatch(getMonthalyDetSummary(body));
            if (res.status === 200 && res.data.status) {
                let reportData = [];
                if (res.data?.Data?.Table?.length > 0) {
                    reportData = groupData(res.data?.Data?.Table)
                }
                const xlColumns = TableHeaderColumn.map((col) => {
                    return { colHeader: col.headerNameV2, field: col.field, xlCol: col.xlCol }
                });
                const xlConfig = {
                    ...excelConfig,
                    columns: xlColumns,
                    fileName: `MONTH_WISE_E-BOOKING_SUMMARY.xlsx`,
                    showFilterSection: true,
                    showSummarySection: true,
                    showEmptyRow: true,
                    headerRowStyle: { fill: '', bold: true },
                    borderStyle: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    },
                    showHeader: false,
                    workSheetTitle: `MONTH_WISE_E-BOOKING_SUMMARY`,
                    headerFooter: {
                        firstHeader: "MONTH_WISE_E-BOOKING_SUMMARY",
                        firstFooter: "MONTH_WISE_E-BOOKING_SUMMARY"
                    },
                    sheetHeaderData: [
                        {
                            "caption": "KARNATAKA STATE ROAD TRANSPORT CORPORATION",
                            "colSpan": 9,
                            "horizontal": "center",
                            "newRow": true
                        },
                        {
                            "caption": "MONTH WISE E-BOOKING SUMMARY",
                            "colSpan": 9,
                            "size": 12,
                            "horizontal": "center",
                            "newRow": true
                        },
                        {
                            "caption": "From Date : ",
                            "value": `${moment(selValues?.bookDate).format("DD-MMM-YYYY")} -To Date:${moment(selValues?.toDate).format("DD-MMM-YYYY")}`,
                            "colSpan": 5,
                            "size": 10,
                        },
                        {
                            "caption": "User : ",
                            "value": `${user?.UserName || ''} (${sessionStorage.getItem('LoginId') || ""})`,
                            "colSpan": 4,
                            "horizontal": "right",
                            "size": 10,
                            "newRow": true
                        },
                        {
                            "caption": "Print Date & Time : ",
                            "value": `${currentDateTime}`,
                            "colSpan": 9,
                            "horizontal": "right",
                            "size": 10
                        },
                        // {
                        //     "caption": "From Date: ",
                        //     "value": `From Date:${moment(selValues?.bookDate).format("DD-MMM-YYYY")} -To Date:${moment(selValues?.toDate).format("DD-MMM-YYYY")}`,
                        //     "colSpan": 5,
                        //     "size": 10,
                        // },
                        // {
                        //     "caption": "To Date:",
                        //     "value": `${user?.UserName} ${moment(window.getTime ? window.getTime() : new Date()).format('DD/MM/YYYY HH:mm:ss')}`,
                        //     "colSpan": 4,
                        //     "horizontal": "right",
                        //     "size": 10
                        // },
                    ],
                };
                await excelExport.processExcel(xlConfig, reportData);
            }
        }
    }
    const pdfGroupData = (array) => {
        let newData = []
        let totalarray = []
        let groupedData = array.reduce((result, item) => {
            // const key = `${item.PGName}`
            const key = item.PGName === 'RAZORPAY' ? 'Kotak - Razorpay' : `Kotak - Easebuzz`
            if (!result[key]) {
                result[key] = []
            } result[key].push(item)
            return result
        }, {})
        Object.keys(groupedData).forEach((key) => {
            let updatedData = [...groupedData[key]]
            const keys = ["SuccessCount", "SuccessAmount", "CancelledCount", "CancelledAmount", "CancelPtc", "FailureCount", "FailureAmount", "FailurePtc"];
            let totals = getTotalByKey(groupedData[key], keys);
            totals = {
                ...totals,
                SuccessAmount: Math.round(Number(totals?.SuccessAmount)),
                CancelledAmount: Math.round(Number(totals?.CancelledAmount)),
                FailureAmount: Math.round(Number(totals?.FailureAmount)),
                CancelPtc: Math.round((totals.CancelledCount * 100) / totals.SuccessCount),
                FailurePtc: Math.round((totals.FailureCount * 100) / totals.SuccessCount),
            }
            totals.TxnDate = "Total"
            totals.isTotal = true
            totalarray.push(totals)
            updatedData.push(totals)
            updatedData.unshift({ isHeaderRow: true, TxnDate: 'Date', SuccessCount: 'Txn', SuccessAmount: 'Amount', CancelledCount: 'Txn', CancelledAmount: 'Amount', CancelPtc: '%', FailureCount: 'Txn', FailureAmount: 'Amount', FailurePtc: '%' },)
            updatedData.unshift({ SuccessCount: "Success", CancelledCount: "Cancelled", FailureCount: "Failure", isSubHeading: true })
            updatedData.unshift({ TxnDate: key, isHeading: true })
            newData = [...newData, ...updatedData]
        })
        const keys = ["SuccessCount", "SuccessAmount", "CancelledCount", "CancelledAmount", "CancelPtc", "FailureCount", "FailureAmount", "FailurePtc"];
        let allTotal = getTotalByKey(totalarray, keys);
        allTotal = {
            ...allTotal,
            SuccessAmount: Math.round(Number(allTotal?.SuccessAmount)),
            CancelledAmount: Math.round(Number(allTotal?.CancelledAmount)),
            FailureAmount: Math.round(Number(allTotal?.FailureAmount)),
            CancelPtc: Math.round((allTotal.CancelledCount * 100) / allTotal.SuccessCount),
            FailurePtc: Math.round((allTotal.FailureCount * 100) / allTotal.SuccessCount),
        }
        allTotal.TxnDate = "Grand Total"
        allTotal.isTotal = true
        newData.push(allTotal)
        return newData
    }
    const generatepdf = async () => {
        if (moment(selValues?.toDate).diff(moment(selValues?.bookDate), "month") > 12) {
            handleAlert("This report cannot be taken for more than 1 year")
        } else {
            const body = {
                CompanyID: user?.CompanyID,
                UserID: user?.UserID,
                TxnDateFrom: selValues?.bookDate,
                TxnDateTo: selValues?.toDate,
                PGType: selValues?.pgType?.[0]?.PGUsed,
            }
            const res = await dispatch(getMonthalyDetSummary(body));
            if (res.status === 200 && res.data.status) {
                let reportData = [];
                if (res.data?.Data?.Table?.length > 0) {
                    reportData = pdfGroupData(res.data?.Data?.Table)
                }

                jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
                jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);
                const pdfColumns = TableHeaderColumn.map((col) => {
                    return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                })
                const widthCell = calculateTotalTableWidth(TableHeaderColumn)
                // const doc = new jsPDF({ orientation: 'l', format: [1080, 1528], unit: 'px', compress: true })
                const doc = new jsPDF({ orientation: pdfColumns.length > 12 ? 'l' : 'p', format: pdfColumns.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 793 ? widthCell : 793) + 60), unit: 'px', compress: true })
                // var pageSize = doc.internal.pageSize
                doc.autoTableSetDefaults({
                    headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
                })
                var totalPagesExp = '{total_pages_count_string}'
                doc.setProperties({
                    title: `Online Report.pdf`,
                    subject: 'Report',
                    author: 'Karnataka State Road Transport Corporation',
                    keywords: 'Mantis Technologies Private Limited',
                    creator: 'KSRTC',
                })
                autoTable(doc, {
                    margin: { top: 180, left: 30, right: 30, bottom: 40 },
                    alternateRowStyles: {
                        fillColor: [255, 255, 255],
                    },
                    columns: pdfColumns,
                    body: reportData,
                    columnStyles: {
                        0: { halign: 'left', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        1: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        2: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        3: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        4: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        5: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        6: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        7: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        8: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                    },
                    showHead: 'never',
                    theme: 'grid',
                    styles: {
                        lineWidth: [0, 0.2, 0, 0.6],
                    },
                    tableLineWidth: 0.6,
                    headStyles: {
                        fontSize: 16,
                        fillColor: [255, 255, 255],
                        textColor: [0, 0, 0],
                        cellPadding: 6,
                        valign: 'middle',
                        fontStyle: 'normal',
                        font: 'Roboto',

                    },
                    didParseCell: (data) => {
                        // drawCell(data)
                        if (data.row.section === 'head') {
                            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                                data.cell.styles.halign = 'right'
                            } else {
                                data.cell.styles.halign = 'left'
                            }
                        }
                    },
                    didDrawPage: function (data) {
                        var doc = data.doc;
                        doc.setTextColor('#000000');

                        // Calculate text width and center for the first text
                        var text1 = 'KARNATAKA STATE ROAD TRANSPORT CORPORATION';
                        var textWidth1 = doc.getStringUnitWidth(text1) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                        var centerX1 = (doc.internal.pageSize.width - textWidth1) / 2;

                        // Set font size and style for the first text
                        doc.setFontSize(18).setFont("Roboto", 'normal', '700');
                        doc.setTextColor('#000000');
                        // Draw the first text at the calculated x-coordinate
                        doc.text(text1, centerX1, 60);

                        // Set font size, weight, and color for the second text
                        doc.setFontSize(14).setFont("Roboto", 'normal', '600');
                        doc.setTextColor('#000000');
                        // Calculate text width and center for the second text
                        var text2 = 'MONTH WISE E-BOOKING SUMMARY';
                        var textWidth2 = doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                        var centerX2 = (doc.internal.pageSize.width - textWidth2) / 2;
                        // Draw the second text at the calculated x-coordinate below the first text
                        doc.text(text2, centerX2, 80); // Adjust the vertical position as needed
                        doc.setTextColor(0, 0, 0)
                        doc.setFontSize(18)
                        doc.setFont('Roboto', '')
                        doc.text(`From Date:${moment(selValues?.bookDate).format("DD-MMM-YYYY")} -To Date:${moment(selValues?.toDate).format("DD-MMM-YYYY")}`, 30, 170)
                        doc.setFontSize(18)
                        doc.setFont('Roboto', '')
                        doc.text(`User : ${user?.UserName || ''} (${sessionStorage.getItem('LoginId') || ""})`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
                        doc.text(`Print Date & Time : ${currentDateTime}`, doc.internal.pageSize.width - data.settings.margin.left, 170, 'right')
                    },
                })
                autoTable(doc, {
                    margin: { left: 30, right: 30, bottom: 0 },
                    startY: doc.lastAutoTable.finalY + 12,
                    theme: 'grid',
                    head: [],
                    body: [['Note : % Value calculated based on Cancelled Txn. * 100/Success Txn. & Failure Txn. * 100 /Success Txn.']],
                    bodyStyles: {
                        textColor: [0, 0, 0],
                        minCellHeight: 36,
                        valign: 'middle',
                        halign: "center",
                        cellPadding: 6,
                        fontSize: 14,
                        lineWidth: 0,
                        font: 'Roboto',
                        fontStyle: "bold"
                    },
                    didParseCell: function (data) {
                        if (data.row.index === 0) {
                            data.cell.styles.textColor = '#FF5555'
                        }
                    },
                })
                doc.setFont('Roboto')

                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save(`MONTH WISE E-BOOKING SUMMARY ${new Date().getTime()}.pdf`)
            } else {
                handleAlert(res.data?.Message);
            }
        }
    }
    const handleAlert = (msg) => {
        setShowAlert(true)
        setAlertMsg(msg)
    }
    const handleResetValue = () => {
        setSelValues({
            bookDate: moment(formatDate(window.getTime ? window.getTime() : new Date())).format("YYYY-MM-") + "01",
            toDate: moment(formatDate(window.getTime ? window.getTime() : new Date())).format("YYYY-MM-") + moment(formatDate(window.getTime ? window.getTime() : new Date())).daysInMonth(),
            pgType: [paymentGatewayList[0] || []],
        })
    }
    const handleSumbit = async () => {
        setShowReport(false)
        setReportTableData({})
        if (moment(selValues?.toDate).diff(moment(selValues?.bookDate), "month") > 12) {
            handleAlert("This report cannot be taken for more than 1 year")
        } else {
            const headerData = {
                fromDate: selValues?.bookDate,
                toDate: selValues?.toDate,
            };
            const body = {
                CompanyID: user?.CompanyID,
                UserID: user?.UserID,
                TxnDateFrom: selValues?.bookDate,
                TxnDateTo: selValues?.toDate,
                PGType: selValues?.pgType?.[0]?.PGUsed,
            }
            dispatch(getMonthalyDetSummary(body)).then((res) => {
                if (res?.status === 200 && res?.data?.status) {
                    if (res?.data?.Data?.Table?.length > 0) {
                        setShowReport(true)
                        setReportTableData({ header: headerData, TableData: res?.data?.Data?.Table })
                    } else {
                        handleAlert('No Data Found!');
                        // setShowReport(true)
                        setReportTableData({ header: headerData, TableData: [] })
                    }
                } else {
                    handleAlert(res.data?.Message);
                }
            })
        }
    }
    return (
        <>
            {!showReport ?
                <Box>
                    <ReportHeader mainHeaderName='Report' headerName='Online Report' openSubMenu={() => dispatch(reportMenu(true))} subHeader={'MONTH WISE E-BOOKING SUMMARY'} subHeaderVisible={() => dispatch(onlineReportMenu(true))} mainMenuOpen={true} />
                    <Grid
                        container
                        spacing={0}
                        className="column-container"
                        style={{
                            padding: "16px 16px 58px 16px",
                        }}
                    >
                        <Grid item md={6.5}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px'
                            }}
                        >
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    fontWeight: '700'
                                }}
                            >
                                <Grid item md={4}>Booked Date</Grid>
                                <Grid item md={8}>
                                    <CustomDatePickerV2 label={''} id="fromBookingDate" selectedDate={selValues.bookDate}
                                        onChange={(value) => {
                                            setSelValues((prev) => ({
                                                ...prev,
                                                bookDate: moment(formatDate(value)).format("YYYY-MM-") + "01",
                                                toDate: moment(formatDate(value)).format("YYYY-MM-") + moment(formatDate(value)).daysInMonth()
                                            }))
                                        }}
                                        minDate={'2024-06-19'}
                                        onKeyDown={(e) => {
                                            navigation1(e, "toBookingDate", "");
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    fontWeight: '700'
                                }}
                            >
                                <Grid item md={4}>To Booking Date</Grid>
                                <Grid item md={8}>
                                    <CustomDatePickerV2 label={''} id="toBookingDate" selectedDate={selValues.toDate}
                                        onChange={(value) => {
                                            setSelValues((prev) => ({
                                                ...prev,
                                                toDate: moment(formatDate(value)).format("YYYY-MM-") + moment(formatDate(value)).daysInMonth()
                                            }))
                                        }}
                                        minDate={selValues?.bookDate}
                                        onKeyDown={(e) => {
                                            navigation1(e, "paymentType", "fromBookingDate");
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    fontWeight: '700'
                                }}
                            >
                                <Grid item md={4}>Payment Gateway Type</Grid>
                                <Grid item md={8}>
                                    <MultiSelectDropDown
                                        {...paymentTypeProps()}
                                        onSelect={(val) => setSelValues((prev) => ({
                                            ...prev,
                                            pgType: val
                                        }))}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    gap: '10px',
                                    flexWrap: 'nowrap'
                                }}
                            > <Grid item md={4}></Grid>
                                <Grid item md={2}>
                                    <Button variant="contained" size="medium" id="submitBTN"
                                        className={`btn-orange`}
                                        onClick={() => handleSumbit()}
                                        onKeyDown={(e) => navigation3(e, "pdfBTN", "paymentType", () => { })}

                                    >
                                        SUBMIT
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        id="pdfBTN"
                                        className="btn-orange-outline"
                                        onClick={() => generatepdf(true)}
                                        onKeyDown={(e) => navigation3(e, "excelBTN", "submitBTN", () => { })}
                                    >
                                        PDF
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        className="btn-orange-outline"
                                        id="excelBTN"
                                        onClick={reportExcelExport}
                                        onKeyDown={(e) => navigation3(e, "resetBTN", "pdfBTN", () => { })}
                                    >
                                        EXCEL
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        id="resetBTN"
                                        className="btn-orange-outline"
                                        onClick={() => handleResetValue()}
                                        onKeyDown={(e) => navigation3(e, "", "excelBTN", () => { handleResetValue() })}

                                    >
                                        RESET
                                    </Button>
                                </Grid>
                            </Grid>

                        </Grid>

                    </Grid>
                </Box>
                :
                <MonthWiseEBookingServiceTable reportTableData={reportTableData} handleBack={() => {
                    setReportTableData({});
                    setShowReport(false)
                }} />
            }
            {showAlert && (
                <Alert
                    msg={alertMsg} alertType={"error"} close={() => setShowAlert(false)} buttonText="Ok"
                />
            )}
        </>
    )
}

export default MonthWiseEBookingService